import Router from './routes/routes';
import Navbar from './components/navbar/Navbar';
import Footer from './components/Footer/Footer';
import AnnouncementPopup from './components/AnnouncementPopup';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-phone-input-2/lib/style.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { whatsapp } from './assets/imagesPath';
import ScrollToTop from './components/scrollToTop/ScrollToTop';

import { useGetContactSettingsQuery } from './services/Api';

function App() {
  const { data: settingsData } = useGetContactSettingsQuery();
  const settings = settingsData?.status ? settingsData.data : { whatsapp_number: '+923000828456' };

  const formatWhatsApp = (num) => num?.replace(/[^0-9]/g, '').replace(/^0/, '92');

  const openWhatsAppChat = () => {
    window.open(`https://wa.me/${formatWhatsApp(settings.whatsapp_number)}`, '_blank');
  };

  return (
    <>
      <AnnouncementPopup />
      <ScrollToTop />
      <Navbar />
      <Router />
      <Footer />
      <img src={whatsapp} className='whatsappImg' onClick={openWhatsAppChat} />
    </>
  );
}

export default App;